import React from "react";

import type { AgentUser } from "@/shared/types";

const TONES = {
  success: "bg-[var(--success-bg)] text-[var(--success)] ring-[var(--success-ring)]",
  warn: "bg-[var(--warn-bg)] text-[var(--warn-text)] ring-[var(--warn-ring)]",
  danger: "bg-[var(--danger-bg)] text-[var(--danger)] ring-[var(--danger-ring)]",
};

/** Where a person stands: "Step 2 of 3" while onboarding, Active, or Blocked. */
export function StatusPill({ person }: { person: Pick<AgentUser, "status" | "step"> }) {
  const [tone, label] =
    person.status === "blocked" ? (["danger", "Blocked"] as const)
    : person.status === "onboarding" ? (["warn", person.step ? `Step ${person.step.number} of ${person.step.of}` : "Onboarding"] as const)
    : (["success", "Active"] as const);
  return (
    <span className={`inline-flex whitespace-nowrap rounded-full text-[11.5px] font-medium px-2 py-[2px] ${TONES[tone]}`}>
      {label}
    </span>
  );
}
